export const easyModeChoices = ["paper", "scissor", "rock"];

export const advanceModeChoices = ["paper", "scissor", "rock", "lizard", "spock"];
